import { isPending } from "App/apiMiddleware";
import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getBalance = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].balance`, 0), (balance) => balance);
export const getRequestStatistics = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].history`, []), (billingHistory) => billingHistory);
export const getInProgress = (state) => isPending(state, actionTypes.API_GET_BALANCE) ||
    isPending(state, actionTypes.API_GET_REQUEST_STATISTICS);
